// as-cetra-vet-ui/src/components/authenticated/handout/customise-mode/EditableParagraph.js

import React, { useState, useRef, useEffect } from 'react';
import { Box, Typography, TextField } from '@mui/material';
import { useCustomiseMode } from './CustomiseModeContext';

const EditableParagraph = ({ block, sectionIndex, blockIndex, isEditing, onStartEdit, onFinishEdit }) => {
    const { updateBlock } = useCustomiseMode();
    const [localValue, setLocalValue] = useState(block.value);
    const textFieldRef = useRef(null);

    useEffect(() => {
        if (isEditing && textFieldRef.current) {
            textFieldRef.current.focus();
        }
    }, [isEditing]);

    const handleBlur = () => {
        // Save changes when user clicks away
        updateBlock(sectionIndex, blockIndex, {
            ...block,
            value: localValue,
        });
        onFinishEdit();
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            // Cancel editing, revert to original
            setLocalValue(block.value);
            onFinishEdit();
        }
    };

    if (isEditing) {
        return (
            <TextField
                ref={textFieldRef}
                fullWidth
                multiline
                value={localValue}
                onChange={(e) => setLocalValue(e.target.value)}
                onBlur={handleBlur}
                onKeyDown={handleKeyDown}
                variant="outlined"
                sx={{
                    pb: 1,
                    '& .MuiOutlinedInput-root': {
                        backgroundColor: 'rgba(255, 255, 200, 0.2)', // Light yellow to indicate editing
                    },
                }}
            />
        );
    }

    // Display mode (non-editing)
    return (
        <Typography
            sx={{
                position: 'relative',
                zIndex: 1,
                pb: 1,
                cursor: 'pointer',
                '&:hover': {
                    backgroundColor: 'rgba(0, 4, 83, 0.05)',
                },
                '@media print': {
                    pageBreakInside: 'auto',
                    pageBreakBefore: 'auto',
                    display: 'inline',
                },
            }}
            onClick={onStartEdit}
        >
            {block.value || <em style={{ color: '#999' }}>Empty paragraph - click to edit</em>}
        </Typography>
    );
};

export default EditableParagraph;
